import { checkToken } from "@/api/lst";
import { checkWuyouSession } from "@/api/wuyou";
import { getLstToken, getLstPhone, getLstAuthorization } from "@/utils/lstSessionStorage";
import { getStoredPlatformId, PLATFORM_WUYOU } from "@/utils/apiPlatform";
import { tokenCheckFresh, setTokenCheckResult, clearTokenCheckCache } from "@/utils/tokenCheckCache";
const inflightByKey = new Map();
const inflightKey = (token, phone, auth = "") => `${token}\u001e${phone || ""}\u001e${auth || ""}`;
export function recordLstTokenCheckResult(success) {
    const token = getLstToken();
    if (!token) {
        clearTokenCheckCache();
        return;
    }
    const extra = getStoredPlatformId() === PLATFORM_WUYOU ? getLstAuthorization() : getLstPhone();
    setTokenCheckResult(!!success, token, extra);
}
export async function validateLstToken() {
    const token = getLstToken();
    if (!token) {
        clearTokenCheckCache();
        return { code: 0, message: "\u672A\u767B\u5F55" };
    }
    if (getStoredPlatformId() === PLATFORM_WUYOU) {
        const auth = getLstAuthorization();
        if (!auth)
            return { code: 0, message: "\u7F3A\u5C11 Authorization" };
        const extra = auth;
        if (tokenCheckFresh(token, extra))
            return { code: 1 };
        const key = inflightKey(token, "", auth);
        const existing = inflightByKey.get(key);
        if (existing)
            return existing;
        const checkedToken = token;
        const checkedAuth = auth;
        const p = checkWuyouSession(checkedToken, checkedAuth).then((res) => {
            const nowToken = getLstToken();
            const nowAuth = getLstAuthorization();
            if (nowToken !== checkedToken || nowAuth !== checkedAuth) {
                clearTokenCheckCache();
                return validateLstToken();
            }
            const ok = Number(res?.code) === 200;
            setTokenCheckResult(ok, checkedToken, checkedAuth);
            return ok ? { code: 1 } : { code: 0, message: res?.msg || res?.message || "\u9A8C\u8BC1\u5931\u8D25" };
        }).finally(() => {
            inflightByKey.delete(key);
        });
        inflightByKey.set(key, p);
        return p;
    }
    const phone = getLstPhone();
    if (!phone)
        return { code: 0, message: "\u672A\u767B\u5F55" };
    if (tokenCheckFresh(token, phone))
        return { code: 1 };
    const key = inflightKey(token, phone);
    const existing = inflightByKey.get(key);
    if (existing)
        return existing;
    const checkedToken = token;
    const checkedPhone = phone;
    const p = checkToken(checkedToken, checkedPhone).then((res) => {
        const nowToken = getLstToken();
        const nowPhone = getLstPhone();
        if (nowToken !== checkedToken || nowPhone !== checkedPhone) {
            clearTokenCheckCache();
            return validateLstToken();
        }
        setTokenCheckResult(Number(res?.code) === 1 || res?.success === true, checkedToken, checkedPhone);
        return res;
    }).finally(() => {
        inflightByKey.delete(key);
    });
    inflightByKey.set(key, p);
    return p;
}
export { clearTokenCheckCache } from "@/utils/tokenCheckCache";
